import React from "react";
import { connect } from "react-redux";
import { ReactComponent as BannerImg } from "../assets/images/banner/banner-img.svg";
import { selectCurrentStep } from "../reducers/selectors";
import { createStructuredSelector } from "reselect";
import { Button } from "react-bootstrap";

const Banner = (props) => {
  const onSignUuClick = () => {
    sessionStorage.clear();
    window.location.href = "https://api.textunited.com/jsoneditor/auth/login?ReturnUrl=https://www.textunited.com/json-free-translator/&?checkOnly=Y";
  };
  return (
    <div className="banner animate__slideInDown">
      <div className="container text-start">
        <div className="row">
          <div className="col">
            <div className="text">
              <h1>
                Translate JSON files  for free
              </h1>
              <h4>
                Try our free trial packed <br></br> with rich features and <br></br> extended file processing <br></br> limits
              </h4>
            </div>
          </div>
        </div>
      </div>
      <Button className="bunner-btn  text-center" onClick={() => (window.location.href = "https://www.textunited.com/my/signup/")}>
        SIGN UP
      </Button>
      {props.activeStep === 0 && (
        <Button className="bunner-btn-log  text-center" onClick={() => onSignUuClick()}>
          Log In
        </Button>
      )}
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  activeStep: selectCurrentStep,
});

export default connect(mapStateToProps, null)(Banner);
